import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';
import { styled } from 'linaria/react';
import { itemContent, itemButton } from './project-content/styles';

export const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-right: -0.1px;
  overflow: hidden;
  -webkit-mask-image: -webkit-radial-gradient(circle, black, white);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
    transition: transform 0.3s;
  }
`;

export const mainRounding = css`
  border-radius: var(--rounding-l) var(--rounding-l) 0 0;
`;

export const specialRounding = css`
  border-radius: 0 var(--rounding-l) var(--rounding-l) 0;
`;

export const container = css`
  width: 100%;
  padding-top: var(--space-875);
  padding-bottom: var(--space-500);

  ${breakpoints.only.mobile} {
    padding-top: var(--space-200);
    padding-bottom: var(--space-200);
  }
`;

export const heading = css`
  margin-bottom: var(--space-300);
  ${breakpoints.to.tablet} {
    margin-bottom: var(--space-250);
  }
`;

export const item = css`
  display: flex;
  text-decoration: none;
  background-color: var(--box-color);
  border-radius: var(--rounding-l);
  &.portrait {
    flex-direction: column;
  }
  &.landscape {
    ${breakpoints.from.desktop} {
      flex-direction: row-reverse;
      justify-content: space-between;
      .${itemContent} {
        flex-grow: 1;
      }
    }
    ${breakpoints.to.desktop} {
      flex-direction: column;
      .${itemContent} {
        padding: 0 var(--space-300) var(--space-300);
      }
    }
  }
  @media (pointer: fine) {
    &:hover {
      img {
        transform: scale(1.1);
      }
      .${itemButton} {
        background: rgba(255, 255, 255, 0.24);
      }
    }
  }
`;

export const projects = css`
  width: 100vw;
  max-width: 1180px;
  margin-right: auto;
  margin-left: auto;
  ${breakpoints.only.desktop} {
    width: 100%;
    max-width: 940px;
    padding: 0;
  }
  ${breakpoints.from.desktop} {
    display: grid;
    align-items: stretch;
    grid-column-gap: var(--space-400);
    grid-row-gap: var(--space-400);
    grid-template-columns: 41.079295fr 58.920705fr;
    grid-template-rows: 192px 192px;
    width: 100%;
    justify-items: stretch;
    .${item} {
      grid-column-end: 2;
      grid-column-start: 2;
      &.portrait {
        flex-direction: column;
        grid-column-start: 1;
        grid-row-end: 3;
        grid-row-start: 1;
      }
    }
  }
  ${breakpoints.to.desktop} {
    display: grid;
    align-items: stretch;
    grid-column-gap: var(--space-200);
    grid-template-columns: 1fr 1fr 1fr;
    padding: 0 calc((100vw - var(--layout-width) - 2 * var(--layout-gap)) / 2 + var(--layout-gap));
    overflow-x: scroll;
    scroll-padding: calc((100vw - var(--layout-width) - 2 * var(--layout-gap)) / 2 + var(--layout-gap));
    .${item} {
      width: 283px;
      height: 372px;
      a {
        width: 100%;
      }
      ${breakpoints.only.smMobile} {
        width: 227px;
        height: 338px;
      }
    }
  }
  ${breakpoints.to.tablet} {
    padding: 0 var(--layout-gap);
  }
`;
